/* src/app/modules/shared/button/button.component.scss */
.block {
  width: 100%;
}
/*# sourceMappingURL=button.component-VJZBV5ZY.css.map */
